export const ADDR_REPORT_SELECT_TYPE = Object.freeze({
    TECHNICAL_SUPPORT: 3
});
